import React, {useState, useContext, useEffect} from 'react';
import {Container, Row, Col, Spinner, Button, Tabs, Tab, Form, InputGroup, Modal} from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import {Renew} from './components/renew';
import {Trail} from './components/trails';
import {Pending} from './components/pending';
import {Disabled} from './components/disabled';
import {All} from './components/all';
import { AppContext } from '../App';


export const Accounts=()=>{
	const { user, setUser, link, accessToken, setAccessToken, getExpiredLoad, setGetExpiredLoad, getExpired, expired,
	setExpired } = useContext(AppContext);
	const [ detailModal, setDetailModal ] = useState(false);
	const [ getDetailsLoad, setGetDetailsLoad ] = useState(false);
	const [ details, setDetails ] = useState();
	const getContactDetails=(id)=>{
		setDetailModal(true);
		setGetDetailsLoad(true);
    	axios.post(`${link}api/ss/view/account/details/`,{
    			account_id:id.substring(1),
    		},{
            headers:{
            	Authorization: 'Bearer '+accessToken
            }
          }).then((response)=>{
            setGetDetailsLoad(false);
            setDetails(response.data);
          }).catch((err)=>{
            setGetDetailsLoad(false);
            if(err.response.status === 401){
                setAccessToken();
            }else if(err.response.status === 404){
                console.log('View_account_details - ',err.response.status,':',err.response.statusText);
            }else if(err.response.status === 500){
                console.log('View_account_details - ',err.response.status,':',err.response.statusText);
            }else{
                console.log('View_account_details - ',err.response.status,':',err.response.data);
            }
      	});
	}
	const [ pending, setPending ] = useState();
	const [ trailAccounts, setTrailAccounts ] = useState();
	const [ disabledAccount, setDisabledAccount ] = useState();
	const [ allAccounts, setAllAccounts ] = useState();
	const [ tabName, setTabName ] = useState('renew');
	const [ summary, setSummary ] = useState();
	const getSummary=()=>{
		setGetExpiredLoad(true);
	    axios.get(`${link}api/ss/view/summary/`,{
	          headers:{
	            Authorization: 'Bearer '+accessToken
	          }
	        }).then((response)=>{
	          setGetExpiredLoad(false);
	          setSummary(response.data);
	        }).catch((err)=>{
	          setGetExpiredLoad(false);
	          if(err.response.status === 401){
	              setAccessToken();
	          }else if(err.response.status === 404){
	              console.log('Get_trail_accounts - ',err.response.status,':',err.response.statusText);
	          }else if(err.response.status === 500){
	              console.log('Get_trail_accounts - ',err.response.status,':',err.response.statusText);
	          }else{
	              console.log('Get_trail_accounts - ',err.response.status,':',err.response.data);
	          }
	    });
	}
	const tabChange=(key)=>{
		if (key==='expiried') {
			setTabName('renew');
			getExpired();
			setSearchResult(prev=>({}));
		}else if (key==='pending') {
			setTabName('pending');
			getPendingAccounts();
			setSearchResult(prev=>({}));
		}else if (key==='trail') {
			setTabName('trail');
			getTrailAccounts();
			setSearchResult(prev=>({}));
		}else if(key==='disabled'){
			setTabName('disabled');
			getDisabledAccounts();
			setSearchResult(prev=>({}));
		}else if (key==='all') {
			setTabName('all');
			setSearchResult(prev=>({}));
			getAllAccounts();
		}else if(key==='summary'){
			getSummary();
			setSearchResult(prev=>({}));
		}
	}
	const [ addNewModal, setAddNewModal ] = useState(false);
	useEffect(()=>{
		if (!addNewModal) {
			setValidUser();
			setValidEmail();
			setTrailChecked(false);
			setPayChecked(false);
		}
	},[addNewModal]);
	const [ reqUsername, setReqUsername ] = useState(false);
	const [ reqEmail, setReqEmail ] = useState(false);
	const [ reqPass, setReqPass ] = useState(false);
	const [ reqCpass, setReqCpass ] = useState(false);
	const [ checReq, setCheckReq ] = useState(false);
	const [ validUser, setValidUser ] = useState();
	const [ usernameCheckLoad, setUsernameCheckLoad ] = useState(false);
	const checkUsername=(username)=>{
		if (username!=="") {
			setUsernameCheckLoad(true);
			axios.post(`${link}api/ss/get/user/name/`,{
					username:username,
		        },{
		          headers:{
		            Authorization: 'Bearer '+accessToken
		          }
		        }).then((response)=>{
		        	setUsernameCheckLoad(false);
		        	setValidUser(response.data);
		        }).catch((err)=>{
		        	setUsernameCheckLoad(false);
			        if(err.response.status === 401){
			            setAccessToken();
			        }else if(err.response.status === 404){
			            console.log('Check_username_availability - ',err.response.status,':',err.response.statusText);
			        }else if(err.response.status === 500){
			            console.log('Check_username_availability - ',err.response.status,':',err.response.statusText);
			        }else{
			            console.log('Check_username_availability - ',err.response.status,':',err.response.data);
			        }
		    });
		    }else{
		    	setValidUser();
		    }
	}
	const [ validEmail, setValidEmail ] = useState();
	const [ emailCheckLoad, setEmailCheckLoad ] = useState(false);
	const checkEmail=(email)=>{
		if (email!=="") {
			setEmailCheckLoad(true);
			axios.post(`${link}api/ss/get/email/id/`,{
					email:email,
		        },{
		          headers:{
		            Authorization: 'Bearer '+accessToken
		          }
		        }).then((response)=>{
		        	setEmailCheckLoad(false);
		        	setValidEmail(response.data);
		        }).catch((err)=>{
		        	setEmailCheckLoad(false);
			        if(err.response.status === 401){
			            setAccessToken();
			        }else if(err.response.status === 404){
			            console.log('Check_email_availability - ',err.response.status,':',err.response.statusText);
			        }else if(err.response.status === 500){
			            console.log('Check_email_availability - ',err.response.status,':',err.response.statusText);
			        }else{
			            console.log('Check_email_availability - ',err.response.status,':',err.response.data);
			        }
		    });
		    }else{
		    	setValidEmail();
		    }
	}
	const [ trailChecked, setTrailChecked ] = useState(false);
	const [ payChecked, setPayChecked ] = useState(false);
	const [ passMatchErr, setPassMatchErr ] = useState(false);
	const [ addAccountLoad, setAddAccountLoad ] = useState(false);
	const [ serverError, setServerError ] = useState(false);
	const addAccount=(e)=>{
		e.preventDefault();
		let username = e.target.username.value;
		let email = e.target.email.value;
		let pass = e.target.password.value;
		let cpass = e.target.password2.value;
		let contact = e.target.contact.value;
		let trail = e.target.trail!==undefined?e.target.trail.checked:'';
		let pay = e.target.payment!==undefined?e.target.payment.checked:'';
		if (username==="") {
			setReqUsername(true);
			setTimeout(()=>{setReqUsername(false)},5000);
		}
		if (email==="") {
			setReqEmail(true);
			setTimeout(()=>{setReqEmail(false)},5000);
		}
		if (pass==="") {
			setReqPass(true);
			setTimeout(()=>{setReqPass(false)},5000);
		}
		if (cpass==="") {
			setReqCpass(true);
			setTimeout(()=>{setReqCpass(false)},5000);
		}
		if (trail===false&&pay===false) {
			setCheckReq(true);
			setTimeout(()=>{setCheckReq(false)},5000);
		}
		if (pass!==""&&cpass!=="") {
			if (pass!==cpass) {
				setPassMatchErr(true);
				setTimeout(()=>{setPassMatchErr(false)},5000);
			}
		}

		if (username!==""&&email!==""&&pass!==""&&cpass!=="") {
			if (trail===true||pay===true) {
				if (pass===cpass) {
					if (validUser!==undefined&&!validUser&&validEmail!==undefined&&!validEmail) {
						setAddAccountLoad(true);
				    	axios.post(`${link}api/ss/add/account/`,{
				    			username:username,
				    			email:email,
				    			password:pass,
				    			trail:trail,
				    			paid:pay,
				    			contact_details:contact,
				    			return_page:tabName,
				    		},{
				            headers:{
				            	Authorization: 'Bearer '+accessToken
				            }
				          }).then((response)=>{
				            setAddAccountLoad(false);
				            if (!response.data.error) {
					            setAddNewModal(false);				            
					            if (tabName==='renew') {
					            	setExpired(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='pending'){
					            	setPending(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='disabled'){
					            	setDisabledAccount(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if (tabName==='trail') {
					            	setTrailAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='all'){
					            	setAllAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }
					        }else{
					        	setServerError(true);
					        	setTimeout(()=>{setServerError(false)},5000);
					        }
				          }).catch((err)=>{
				            setAddAccountLoad(false);
				            setServerError(true);
					        setTimeout(()=>{setServerError(false)},5000);
				            if(err.response.status === 401){
				                setAccessToken();
				            }else if(err.response.status === 404){
				                console.log('Add_account - ',err.response.status,':',err.response.statusText);
				            }else if(err.response.status === 500){
				                console.log('Add_account - ',err.response.status,':',err.response.statusText);
				            }else{
				                console.log('Add_account - ',err.response.status,':',err.response.data);
				            }
				      	});
					}
				}
			}
		}

	}
	const getTrailAccounts=()=>{
		setGetExpiredLoad(true);
	    axios.get(`${link}api/ss/get/trail/accounts/`,{
	          headers:{
	            Authorization: 'Bearer '+accessToken
	          }
	        }).then((response)=>{
	          setGetExpiredLoad(false);
	          setTrailAccounts(response.data.values);
	          setUser(prev=>({...prev,counts:response.data.counts}));
	        }).catch((err)=>{
	          setGetExpiredLoad(false);
	          if(err.response.status === 401){
	              setAccessToken();
	          }else if(err.response.status === 404){
	              console.log('Get_trail_accounts - ',err.response.status,':',err.response.statusText);
	          }else if(err.response.status === 500){
	              console.log('Get_trail_accounts - ',err.response.status,':',err.response.statusText);
	          }else{
	              console.log('Get_trail_accounts - ',err.response.status,':',err.response.data);
	          }
	    });
	}
	const getPendingAccounts=()=>{
		setGetExpiredLoad(true);
	    axios.get(`${link}api/ss/get/pending/payment/accounts/`,{
	          headers:{
	            Authorization: 'Bearer '+accessToken
	          }
	        }).then((response)=>{
	          setGetExpiredLoad(false);
	          setPending(response.data.values);
	          setUser(prev=>({...prev,counts:response.data.counts}));
	        }).catch((err)=>{
	          setGetExpiredLoad(false);
	          if(err.response.status === 401){
	              setAccessToken();
	          }else if(err.response.status === 404){
	              console.log('Get_Payment_pending_accounts - ',err.response.status,':',err.response.statusText);
	          }else if(err.response.status === 500){
	              console.log('Get_Payment_pending_accounts - ',err.response.status,':',err.response.statusText);
	          }else{
	              console.log('Get_Payment_pending_accounts - ',err.response.status,':',err.response.data);
	          }
	    });
	}
	const getDisabledAccounts=()=>{
		setGetExpiredLoad(true);
	    axios.get(`${link}api/ss/get/disabled/accounts/`,{
	          headers:{
	            Authorization: 'Bearer '+accessToken
	          }
	        }).then((response)=>{
	          setGetExpiredLoad(false);
	          setDisabledAccount(response.data.values);
	          setUser(prev=>({...prev,counts:response.data.counts}));
	        }).catch((err)=>{
	          setGetExpiredLoad(false);
	          if(err.response.status === 401){
	              setAccessToken();
	          }else if(err.response.status === 404){
	              console.log('Get_disabled_accounts - ',err.response.status,':',err.response.statusText);
	          }else if(err.response.status === 500){
	              console.log('Get_disabled_accounts - ',err.response.status,':',err.response.statusText);
	          }else{
	              console.log('Get_disabled_accounts - ',err.response.status,':',err.response.data);
	          }
	    });
	}
	const getAllAccounts=()=>{
		setGetExpiredLoad(true);
	    axios.get(`${link}api/ss/get/all/accounts/`,{
	          headers:{
	            Authorization: 'Bearer '+accessToken
	          }
	        }).then((response)=>{
	          setGetExpiredLoad(false);
	          setAllAccounts(response.data.values);
	          setUser(prev=>({...prev,counts:response.data.counts}));
	        }).catch((err)=>{
	          setGetExpiredLoad(false);
	          if(err.response.status === 401){
	              setAccessToken();
	          }else if(err.response.status === 404){
	              console.log('Get_all_accounts - ',err.response.status,':',err.response.statusText);
	          }else if(err.response.status === 500){
	              console.log('Get_all_accounts - ',err.response.status,':',err.response.statusText);
	          }else{
	              console.log('Get_all_accounts - ',err.response.status,':',err.response.data);
	          }
	    });
	}
	const [ renewId, setRenewId ] = useState();
	const [ renewLoad, setRenewLoad ] = useState(false);
	function errorAlert() {
		$.alert({
	        title: 'Encountered an error!',
	        content: 'Something went wrong',
	        type: 'red',
	        typeAnimated: true,
	        buttons: {
	            close: function () {
	            }
	        }
	    });
	}
	const postRenew=(rid,pay)=>{
		setRenewLoad(true);
    	axios.post(`${link}api/ss/renew/account/`,{
    			return_page:tabName,
    			account_id:rid.substring(1),
    			paid:pay,
    		},{
            headers:{
            	Authorization: 'Bearer '+accessToken
            }
          }).then((response)=>{
            setRenewLoad(false);
            setRenewId();
            if (!response.data.error) {			            
	            if (tabName==='renew') {
	            	setExpired(response.data.values);
	            	setUser(prev=>({...prev,counts:response.data.counts}));
	            }else if(tabName==='pending'){
	            	setPending(response.data.values);
	            	setUser(prev=>({...prev,counts:response.data.counts}));
	            }else if(tabName==='disabled'){
	            	setDisabledAccount(response.data.values);
	            	setUser(prev=>({...prev,counts:response.data.counts}));
	            }else if (tabName==='trail') {
	            	setTrailAccounts(response.data.values);
	            	setUser(prev=>({...prev,counts:response.data.counts}));
	            }else if(tabName==='all'){
	            	setAllAccounts(response.data.values);
	            	setUser(prev=>({...prev,counts:response.data.counts}));
	            }
	        }else{
	        	errorAlert();
	        }
          }).catch((err)=>{
            setRenewLoad(false);
            setRenewId();
            errorAlert();
            if(err.response.status === 401){
                setAccessToken();
            }else if(err.response.status === 404){
                console.log('Renew_account - ',err.response.status,':',err.response.statusText);
            }else if(err.response.status === 500){
                console.log('Renew_account - ',err.response.status,':',err.response.statusText);
            }else{
                console.log('Renew_account - ',err.response.status,':',err.response.data);
            }
      	});
	}
	const renewAccount = (rid,username) =>{
			setRenewId(rid);
		    $.confirm({
	        title: 'Do you received payment ?',
	        content: 'Account username : '+username,
	        type: 'blue',
	        typeAnimated: true,
	        buttons: {
	            cash: {
	                text: 'yes',
	                btnClass: 'btn-blue',
	                action: function(){
	                	$.confirm({
						    title: 'Confirm renewal',
						    buttons: {
						        confirm:{
						         text: 'Confirm',
	                			 btnClass: 'btn-blue',
						         action:function () {
							            postRenew(rid,true);
							        }
							    },
						        cancel: function () {},
						    }
						});
	                }
	            },
	            no_cash:{
	            		text:'No',
	            		btnClass:'btn-blue',
	            		action:function(){
	            			$.confirm({
						    title: 'Confirm renewal',
						    buttons: {
						        confirm:{
						         text: 'Confirm',
	                			 btnClass: 'btn-blue',
						         action:function () {
							            postRenew(rid,false);
							        }
							    },
						        cancel: function () {},
						    }
							});
	            		}
	            },
	            cancel: function () {}
	        }
	    });
	}
	const [ disableId, setDisableId ] = useState();
	const [ disableLoad, setDisableLoad ] = useState(false);
	const disableAccount=(did,username)=>{
		setDisableId(did);
		$.confirm({
	        title: 'Do you want to disable account ?',
	        content: 'Account username : '+username,
	        type: 'blue',
	        typeAnimated: true,
	        buttons: {
	            ok: {
	                text: 'Disable',
	                btnClass: 'btn-blue',
	                action: function(){
	                	setDisableLoad(true);
				    	axios.post(`${link}api/ss/disable/account/`,{
				    			return_page:tabName,
				    			account_id:did.substring(1),
				    		},{
				            headers:{
				            	Authorization: 'Bearer '+accessToken
				            }
				          }).then((response)=>{
				            setDisableLoad(false);
				            setRenewId();
				            if (!response.data.error) {			            
					            if (tabName==='renew') {
					            	setExpired(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='pending'){
					            	setPending(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='disabled'){
					            	setDisabledAccount(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if (tabName==='trail') {
					            	setTrailAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='all'){
					            	setAllAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }
					        }else{
					        	errorAlert();
					        }
				          }).catch((err)=>{
				            setDisableLoad(false);
				            setRenewId();
				            errorAlert();
				            if(err.response.status === 401){
				                setAccessToken();
				            }else if(err.response.status === 404){
				                console.log('Disable_account - ',err.response.status,':',err.response.statusText);
				            }else if(err.response.status === 500){
				                console.log('Disable_account - ',err.response.status,':',err.response.statusText);
				            }else{
				                console.log('Disable_account - ',err.response.status,':',err.response.data);
				            }
				      	});
	                }
	            },
	            cancel: function () {}
	        }
	    });
	}
	const [ enableId, setEnableId ] = useState();
	const [ enableLoad, setEnableLoad ] = useState(false);
	const enableAccount=(did,username)=>{
		setEnableId(did);
		$.confirm({
	        title: 'Do you want to enable account ?',
	        content: 'Account username : '+username,
	        type: 'blue',
	        typeAnimated: true,
	        buttons: {
	            ok: {
	                text: 'Enable',
	                btnClass: 'btn-blue',
	                action: function(){
	                	setEnableLoad(true);
				    	axios.post(`${link}api/ss/enable/account/`,{
				    			return_page:tabName,
				    			account_id:did.substring(1),
				    		},{
				            headers:{
				            	Authorization: 'Bearer '+accessToken
				            }
				          }).then((response)=>{
				            setEnableLoad(false);
				            setEnableId();
				            if (!response.data.error) {			            
					            if (tabName==='renew') {
					            	setExpired(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='pending'){
					            	setPending(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='disabled'){
					            	setDisabledAccount(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if (tabName==='trail') {
					            	setTrailAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='all'){
					            	setAllAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }
					        }else{
					        	errorAlert();
					        }
				          }).catch((err)=>{
				            setEnableLoad(false);
				            setEnableId();
				            errorAlert();
				            if(err.response.status === 401){
				                setAccessToken();
				            }else if(err.response.status === 404){
				                console.log('Disable_account - ',err.response.status,':',err.response.statusText);
				            }else if(err.response.status === 500){
				                console.log('Disable_account - ',err.response.status,':',err.response.statusText);
				            }else{
				                console.log('Disable_account - ',err.response.status,':',err.response.data);
				            }
				      	});
	                }
	            },
	            cancel: function () {}
	        }
	    });
	}
	const [ payId, setPayId ] = useState();
	const [ payReciveLoad, setPayReciveLoad ] = useState(false);
	const payRecived=(pid,username)=>{
		setPayId(pid);
		$.confirm({
	        title: 'Confirm payment received ?',
	        content: 'Account username : '+username,
	        type: 'blue',
	        typeAnimated: true,
	        buttons: {
	            ok: {
	                text: 'Confirm',
	                btnClass: 'btn-blue',
	                action: function(){
	                	setPayReciveLoad(true);
				    	axios.post(`${link}api/ss/collect/account/payment/`,{
				    			return_page:tabName,
				    			renew_id:pid,
				    		},{
				            headers:{
				            	Authorization: 'Bearer '+accessToken
				            }
				          }).then((response)=>{
				            setPayReciveLoad(false);
				            setPayId();
				            if (!response.data.error) {				            
					            if (tabName==='renew') {
					            	setExpired(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='pending'){
					            	setPending(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='disabled'){
					            	setDisabledAccount(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if (tabName==='trail') {
					            	setTrailAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }else if(tabName==='all'){
					            	setAllAccounts(response.data.values);
					            	setUser(prev=>({...prev,counts:response.data.counts}));
					            }
					        }else{
					        	errorAlert();
					        }
				          }).catch((err)=>{
				            setPayReciveLoad(false);
				            setPayId();
				            errorAlert();
				            if(err.response.status === 401){
				                setAccessToken();
				            }else if(err.response.status === 404){
				                console.log('Collect_payment - ',err.response.status,':',err.response.statusText);
				            }else if(err.response.status === 500){
				                console.log('Collect_payment - ',err.response.status,':',err.response.statusText);
				            }else{
				                console.log('Collect_payment - ',err.response.status,':',err.response.data);
				            }
				      	});
	                }
	            },
	            cancel: function () {}
	        }
	    });
	}
	const [ searchResult, setSearchResult ] = useState({});
	const searchMap=(keyword,arr)=>{
		setSearchResult(prev=>({}));
		if (arr!==undefined){
			if (Object.keys(arr).length>0){
				Object.keys(arr).map((item,index)=>{
					if(arr[item].account_name.toLowerCase().includes(keyword.toLowerCase())){
							setSearchResult(prev=>({...prev,[item]:arr[item]}));
					}
				});
			}
		}
	}
	const search=(keyword)=>{
		if(keyword!==""&&tabName!==undefined){
			if (tabName==='renew') {
				searchMap(keyword,expired);
			}else if (tabName==='pending') {
				searchMap(keyword,pending);
			}else if (tabName==='trail') {
				searchMap(keyword,trailAccounts);
			}else if(tabName==='disabled'){
				searchMap(keyword,disabledAccount);
			}else if (tabName==='all') {
				searchMap(keyword,allAccounts);
			}
		}else{
			setSearchResult(prev=>({}));
		}
	}
	useEffect(()=>{
		let x = $('#search_box').val();
		if (x!=="") {
			search(x);
		}
	},[expired, trailAccounts, pending, disabledAccount, allAccounts]);
	const [ remitId, setRemitId ] = useState()
	const [ remitLoad, setRemitLoad ] = useState(false);
	const remitAccount=(id)=>{
		$.confirm({
	        title: 'Confirm Remitted',
	        content: 'Do you want to add account to remitted ?',
	        type: 'blue',
	        typeAnimated: true,
	        buttons: {
	        	ok: {
	                text: 'OK',
	                btnClass: 'btn-blue',
	                action: function(){
	                	setRemitLoad(true);
				    	axios.post(`${link}api/ss/collect/account/remittence/`,{
				    			r_id:id.substring(1),
				    		},{
				            headers:{
				            	Authorization: 'Bearer '+accessToken
				            }
				          }).then((response)=>{
				            setRemitLoad(false);
				            setRemitId();
				            setSummary(response.data);
				          }).catch((err)=>{
				            setRemitLoad(false);
				            setRemitId();
				            errorAlert();
				            if(err.response.status === 401){
				                setAccessToken();
				            }else if(err.response.status === 404){
				                console.log('Collect_account_remitance - ',err.response.status,':',err.response.statusText);
				            }else if(err.response.status === 500){
				                console.log('Collect_account_remitance - ',err.response.status,':',err.response.statusText);
				            }else{
				                console.log('Collect_account_remitance - ',err.response.status,':',err.response.data);
				            }
				      	});
	                }	
	            },
	            cancel: function () {	
	            	setRemitId();
	            }
	        }
	    });
	}
	return(
			<Container className="py-3">
				<Col  xs={12} sm={12} md={12} lg={12} className='bdr2 br-3 mb-3' >
					<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
						<span>{getExpiredLoad?(<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>):'Accounts.'}</span>
						<Button onClick={()=>{setAddNewModal(true)}} className="btn-t1" ><i className="bi bi-plus-circle"></i> Add new</Button>

					</Col>
				</Col>
				<Col xs={12} sm={12} md={12} lg={12} className="service-search mb-1" >
	    			<Form>
	    				<InputGroup>
	    					<Form.Control onChange={(e)=>{search(e.target.value)}} id="search_box" className="br-2" size="lg" type="text" placeholder="Search by username" />
	    					<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
	    				</InputGroup>
	    			</Form>
	    		</Col>
				<Tabs defaultActiveKey="expiried" className="mt-2" onSelect={(e)=>{tabChange(e)}} >
					<Tab eventKey="expiried" title={`Upcoming Renewables ( ${user!==undefined?user.counts.expired:''} )`} className="tab-body" >
						<Renew details={getContactDetails} rid={renewId} renewLoad={renewLoad} 
						renewAccount={renewAccount} did={disableId} disLoad={disableLoad} disAcc={disableAccount}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
					</Tab>
					<Tab eventKey="trail" title={`Trail Accounts ( ${user!==undefined?user.counts.trails:''} )`} className="tab-body" >
						<Trail accounts={trailAccounts} details={getContactDetails} rid={renewId} renewLoad={renewLoad}
						renewAccount={renewAccount} did={disableId} disLoad={disableLoad} disAcc={disableAccount}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
					</Tab>
					<Tab eventKey="pending" title={`Pending Payments ( ${user!==undefined?user.counts.pending:''} )`} className="tab-body" >
						<Pending accounts={pending} details={getContactDetails} did={disableId} disLoad={disableLoad}
						disAcc={disableAccount} payid={payId} paRecLoad={payReciveLoad} payRecive={payRecived}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
					</Tab>
					<Tab eventKey="disabled" title={`Disabled Accounts ( ${user!==undefined?user.counts.disabled:''} ) `} className="tab-body" >
						<Disabled accounts={disabledAccount} details={getContactDetails} rid={renewId} renewLoad={renewLoad}
						renewAccount={renewAccount} did={disableId} disLoad={disableLoad} disAcc={disableAccount}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad}  search={searchResult}  />
					</Tab>
					<Tab eventKey="all" title={`All ( ${user!==undefined?user.counts.all:''} ) `} className="tab-body" >
						<All accounts={allAccounts} details={getContactDetails} did={disableId} disLoad={disableLoad}
						disAcc={disableAccount}  search={searchResult} 
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} />
					</Tab>
					<Tab eventKey="summary" title={`Summary`} className="tab-body" >
						{
							summary!==undefined?(
							<Row className="mx-0">											
			        			<div className="detail-grid px-3 py-2  tp2">
			        				<span>Amount to be remitted</span>
			        				<span>{summary.pending_amount}</span>
			        			</div>
								<div className="detail-grid px-3 pb-2 tp2">
			        				<span>Remaining remittance accounts</span>
			        				<div>
			        					<span className="d-grid">{summary.pending_count}</span>
			        					<div className="renewed-users">
			        						{
			        							summary.values!==undefined?(
			        								Object.keys(summary.values).length>0?(
			        									Object.keys(summary.values).map((item,i)=>(
			        										<div onClick={()=>{
			        											setRemitId(item);
			        											remitAccount(item);
			        										}} className="remit-item bdr1 br-3 bgs1 m-1 p-2" key={`remi_${i}`} >
			        											{
			        												remitId!==undefined&&remitId===item&&remitLoad?(
			        													<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
			        												):(
			        													<span className="detail-grid f18" >{summary.values[item].account_name}</span>
			        												)
			        											}
			        											<span className="f12" >Expiry : {summary.values[item].expiry_date}</span>
			        										</div>
			        									))
			        								):'Nothing found in remittance'
			        							):'Fetching data...'
			        						}
			        					</div>
			        				</div>
			        			</div>
		        			</Row>								
							):''
						}
					</Tab>
				</Tabs>
				<Modal size="lg" show={detailModal} backdrop="static" onHide={()=>{setDetailModal(false)}}>
			        <Modal.Header closeButton>
			          <Modal.Title>Account details</Modal.Title>
			        </Modal.Header>
			        <Modal.Body>
			        {
			        	getDetailsLoad?(
			        		<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
			        	):(
			        		details!==undefined?(
			        		<Row>
			        			<div className="detail-grid mb-3 bdrb2">
			        				<span>Center name</span>
			        				<span>{details.center_name}</span>
			        			</div>
			        			<div className="detail-grid mb-3 bdrb2">
			        				<span>Username</span>
			        				<span>{details.username}</span>
			        			</div>
			        			<div className="detail-grid mb-3 bdrb2">
			        				<span>Expiry date</span>
			        				<span>{details.license_expiry_date}</span>
			        			</div>
			        			<div className="detail-grid mb-3 bdrb2">
			        				<span>Contact details</span>
			        				<p className="p-multi-line m-0" >{details.contact_details}</p>
			        			</div>
			        			<div className="detail-grid mb-3 bdrb2">
			        				<span>Phone number</span>
			        				<span>{details.phone_numbers}</span>
			        			</div>
			        			<div className="detail-grid mb-3 bdrb2">
			        				<span>Address</span>
			        				<p className="p-multi-line m-0" >{details.address}</p>
			        			</div>
			        		</Row>
			        		):(<span className="tp3 p-3" >Nothing found!.</span>)
			        	)
			        }				        	
				    </Modal.Body>
				    <Modal.Footer></Modal.Footer>
			    </Modal>
			    <Modal size="lg" show={addNewModal} backdrop="static" onHide={()=>{setAddNewModal(false)}}>
			        <Modal.Header closeButton>
			          <Modal.Title>
				          {
				          	serverError!==undefined&&serverError?(
				          		<span className='error-text' >Something went wrong!</span>
				          	):'Add new account'
				          }
			          </Modal.Title>
			        </Modal.Header>
			        <Modal.Body>
			        	<Form onSubmit={addAccount} >
			        		<Form.Group className="mb-3" >
			        			<Form.Label className="tp2" >Username
			        			{
	        						usernameCheckLoad?(
	        							<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
	        						):(
			        					validUser!==undefined?(
			        						validUser?(
			        						<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Already taken</span>
			        						):(
			        						<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
			        						)
			        					):''
		        					)
			        			}
			        			{reqUsername?(<span className="error-message" >This field is required</span>):''}
			        			</Form.Label>
			        			<Form.Control onBlur={(e)=>{checkUsername(e.target.value)}} type="text" name="username" className="shadow-none br-2" placeholder="Username" />
			        		</Form.Group>
			        		<Form.Group className="mb-3" >
			        			<Form.Label  className="tp2">Email
			        			{
	        						emailCheckLoad?(
	        							<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
	        						):(
			        					validEmail!==undefined?(
			        						validEmail?(
			        						<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Already taken</span>
			        						):(
			        						<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
			        						)
			        					):''
		        					)
			        			}
			        			{reqEmail?(<span className="error-message" >This field is required</span>):''}
			        			</Form.Label>
			        			<Form.Control onBlur={(e)=>{checkEmail(e.target.value)}} type="email" name="email" className="shadow-none br-2" placeholder="Email id" />
			        		</Form.Group>
			        		<Form.Group className="mb-3" >
			        			<Form.Label  className="tp2">Password 
			        			{reqPass?(<span className="error-message" >This field is required</span>):''}
			        			{passMatchErr?(<span className="error-message" >Password and Confirm password do not match!</span>):''}
			        			</Form.Label>
			        			<Form.Control type="password" name="password" className="shadow-none br-2" placeholder="Password" />
			        		</Form.Group>
			        		<Form.Group className="mb-3" >
			        			<Form.Label className="tp2">Confirm Password {reqCpass?(<span className="error-message" >This field is required</span>):''}</Form.Label>
			        			<Form.Control type="password" name="password2" className="shadow-none br-2" placeholder="Confirm password" />
			        		</Form.Group>
			        		<Form.Group className="mb-3" >
			        			<Form.Label className="tp2">Contact details</Form.Label>
			        			<Form.Control as="textarea" name="contact" className="shadow-none br-2" />
			        		</Form.Group>
			        		{checReq?(
				        		<Row className="mb-1" >
				        			<Col>
				        			<span className="error-message" >Please choose one of them bellow</span>
				        			</Col>
				        		</Row>
			        		):''}
			        		<Row>
			        			<Col>
			        				<Form.Group className="mb-3">
			        				{
			        					payChecked?(
					        				<Form.Check disabled className="tp2" type="checkbox" label="Trail Account" />
										):(
							        		<Form.Check onChange={(e)=>{setTrailChecked(e.target.checked)}} className="tp2" type="checkbox" name="trail" label="Trail Account" />
										)
			        				}
					        		</Form.Group>
			        			</Col>
			        			<Col>
			        				<Form.Group className="mb-3">
			        				{
			        					trailChecked?(
					        					<Form.Check disabled className="tp2" type="checkbox" label="Payment recived" />
			        						):(
					        					<Form.Check onChange={(e)=>{setPayChecked(e.target.checked)}} className="tp2" type="checkbox" name="payment" label="Payment recived" />
			        					)
			        				}
					        		</Form.Group>
			        			</Col>
			        		</Row>
			        		<div className="d-grid">
			        		{
			        			addAccountLoad?(
					    				<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
									):(
			        					<Button type="submit" className="btn-t1">SUBMIT</Button>
			        				)			        			
			        		}
			        		</div>
			        	</Form>			        	
				    </Modal.Body>
				    <Modal.Footer></Modal.Footer>
			    </Modal>
			</Container>
		)
}
